import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { MsdNotes } from "../models";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @returns - GET MSD Notes
 */

export const GetMSDNotes = async (osdNumber: number): Promise<MsdNotes> => {
  try {
    // Get static headers from map
    const staticHeaders = getTrackingHeadersMap(ApiType.MSD_NOTES) || {};
    // Add dynamic OSD-Exception-Number
    const headers = {
      ...staticHeaders,
      "OSD-Exception-Number": osdNumber?.toString(),
    };
    const response = await axios.get(`${getUrl(ApiType.MSD_NOTES)}/${osdNumber}`, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.getMSDNotes, { badRequestOrder: "errorsFirst" });
  }
};
